<section class="pdks-widget" [class.pdks-widget--aktif]="pdks.aktifDurum() === 'calisiyor'" [class.pdks-widget--mola]="pdks.aktifDurum() === 'molada'">
  <header class="pdks-baslik">
    <div class="pdks-logo"><span></span></div>
    <div>
      <strong>PDKS</strong>
      <small>Personel devam kontrolü</small>
    </div>
    <a class="pdks-detay" routerLink="pdks">Detaylar <span>›</span></a>
    <div class="pdks-durum"><i></i>{{ durumYazi }}</div>
  </header>

  <div class="pdks-bilgiler">
    <div class="pdks-bilgi">
      <span class="pdks-ikon pdks-ikon--giris">↗</span>
      <div><small>Giriş saati</small><strong>{{ girisSaati }}</strong></div>
    </div>
    <div class="pdks-bilgi">
      <span class="pdks-ikon pdks-ikon--mola">Ⅱ</span>
      <div><small>Toplam mola</small><strong>{{ toplamMolaStr }}</strong></div>
    </div>
    <div class="pdks-bilgi">
      <span class="pdks-ikon pdks-ikon--cikis">↘</span>
      <div><small>Çıkış saati</small><strong>{{ cikisSaati }}</strong></div>
    </div>
  </div>

  <div class="pdks-alt">
    <div class="pdks-sure"><small>Bugünkü net süre</small><strong>{{ pdks.canliSure() }}</strong></div>
    <div class="pdks-aksiyonlar">
      @switch (pdks.aktifDurum()) {
        @case ('bosta') {
          <button class="pdks-btn pdks-btn--giris" (click)="girisYap()" [disabled]="islemYapiliyor">Giriş Yap</button>
        }
        @case ('calisiyor') {
          <button class="pdks-btn pdks-btn--mola" (click)="molaBaslat()" [disabled]="islemYapiliyor">Mola</button>
          <button class="pdks-btn pdks-btn--cikis" (click)="cikisYap()" [disabled]="islemYapiliyor">Çıkış Yap</button>
        }
        @case ('molada') {
          <button class="pdks-btn pdks-btn--giris" (click)="molaBitir()" [disabled]="islemYapiliyor">Molayı Bitir</button>
        }
      }
    </div>
  </div>

  @if (offline.bekleyenSayisi() > 0) {
    <div class="pdks-offline">{{ offline.bekleyenSayisi() }} çevrimdışı kayıt senkronizasyon bekliyor</div>
  }
</section>
